export type BrowserFamily = "ios" | "edge" | "chrome" | "firefox" | "safari" | "other";
export type OsFamily = "mac" | "windows" | "ios" | "other";
export interface MicPlatform {
    browser: BrowserFamily;
    os: OsFamily;
}

export const detectMicPlatform = (ua: string, maxTouchPoints: number): MicPlatform => {
    // iPadOS Safari sends a Macintosh UA, so touch points are the only tell.
    const isIos = /iPhone|iPad|iPod/.test(ua) || (/Macintosh/.test(ua) && maxTouchPoints > 1);
    if (isIos) return { browser: "ios", os: "ios" };
    const os: OsFamily = /Windows/.test(ua) ? "windows" : /Macintosh/.test(ua) ? "mac" : "other";
    if (/Edg\//.test(ua)) return { browser: "edge", os };
    if (/Firefox\//.test(ua)) return { browser: "firefox", os };
    if (/Chrome\//.test(ua)) return { browser: "chrome", os };
    if (/Safari\//.test(ua)) return { browser: "safari", os };
    return { browser: "other", os };
};

export const currentMicPlatform = (): MicPlatform => {
    if (typeof navigator === "undefined") return { browser: "other", os: "other" };
    return detectMicPlatform(navigator.userAgent || "", navigator.maxTouchPoints || 0);
};
